export default "__VITE_ASSET__07c3f6d8__"